<script>
import selectedProductsComponent from '../selected_products/selected_products.vue';

export default {
  data() {
    return {
      client_comment: '',
      first_name: '',
      last_name: '',
      country: '',
      city: '',
      address: '',
      postcode: '',
      phone: '',
      state: '',
      validators: {
        first_name: {
          valid: null,
          regexp: /^[a-zA-Z]{2,}$/,
          validator: 'first_name',
        },
        last_name: {
          valid: null,
          regexp: /^[a-zA-Z \-]{3,}$/,
          validator: 'last_name',
        },
        country: {
          valid: null,
          regexp: /^[a-zA-Z \-]{3,}$/,
          validator: 'country',
        },
        state: {
          valid: null,
          regexp: /^[a-zA-Z \-]{2,}$/,
          validator: 'state',
        },
        city: {
          valid: null,
          regexp: /^[a-zA-Z \-]{3,}$/,
          validator: 'city',
        },
        address: {
          valid: null,
          validator: 'address',
        },
        postcode: {
          valid: null,
          regexp: /^[a-zA-Z0-9\_\- ]{4,20}$/,
          validator: 'postcode',
        },
        phone: {
          valid: null,
          regexp: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
          validator: 'phone',
        },
      },
    };
  },
  components: {
    selected_products_component: selectedProductsComponent,
  },
  computed: {
    selectedProducts() {
      return this.$store.getters.getSelectedProducts;
    },
    goodConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const good = item.filter((subItem) => subItem.condition === 0);

        return good.length === 0 ? good.length : good.reduce((sum, current) => (
          sum + Number(current.selected_quantity)
        ), 0);
      });
    },
    attentionConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const attention = item.filter((subItem) => subItem.condition === 2);

        return attention.length;
      });
    },
    badConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const bad = item.filter((subItem) => subItem.condition === 1);

        return bad.length;
      });
    },
    isButtonActive() {
      const isInvalid = this.selectedProducts
        .map((item) => item.filter((subItem) => subItem.valid === false).length === 0);

      const invalid = (element) => element === false;

      const validFields = Object.keys(this.validators)
        .filter((key) => this.validators[key].valid === true)
        .length === Object.keys(this.validators).length;

      return !isInvalid.some(invalid) && validFields;
    },
  },
  methods: {
    create() {
      const prepareData = {
        client_comment: this.client_comment,
        first_name: this.first_name,
        last_name: this.last_name,
        country: this.country,
        state: this.state,
        city: this.city,
        address: this.address,
        postcode: this.postcode,
        phone: this.phone,
        products: this.$store.getters.getSelectedProductsIds,
      };

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'iscreate_fbm',
        action_data: JSON.stringify(prepareData),
        inform_message: 'Create FBM',
      });
    },

    isValid() {
      Object.keys(this.validators).forEach((key) => {
        const validator = this.validators[key];
        validator.valid = this.validate(validator.validator);
      });

      return Object.keys(this.validators)
        .filter((key) => this.validators[key].valid === true)
        .length === Object.keys(this.validators).length;
    },

    validate(type, value) {
      if (type === 'address') {
        this.validators[type].valid = value.trim().length > 0;
        return;
      }

      this.validators[type].valid = this.validators[type].regexp.test(value);
    },

    remove(subItem) {
      subItem.selected = false;
    },
  },
};
</script>
<template src="./send_by_address.pug" lang="pug"></template>
